<section class="account-card">
    <div class="account-card__header account-card__mobile">
        <h3 class="title">{{title}}</h3>
    </div>
    <div>
        <ng-content></ng-content>
    </div>
</section>
